module.exports = __webpack_public_path__ + "img/acco.52cfac51.png";